import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  image = "https://customer-assets.emergentagent.com/job_bespoke-realty/artifacts/dg49n26m_BESPOKE%287%29.png"
}) => {
  const siteName = "Bespoke Realty";
  const defaultKeywords = "real estate, homes for sale, Memphis TN, Southaven MS, Olive Branch MS, Black-owned brokerage, woman-led real estate, property management";
  
  return (
    <Helmet>
      <title>{title ? `${title} | ${siteName}` : `${siteName} | Luxury Homes & Property Management in Memphis, TN & North MS`}</title>
      <meta name="description" content={description || "Bespoke Realty is a Black-owned, woman-led brokerage offering personalized real estate services in Memphis, TN and North Mississippi. Buy, sell, or rent with confidence."} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title ? `${title} | ${siteName}` : siteName} />
      <meta property="og:description" content={description || "Black-owned, woman-led brokerage offering personalized real estate services in Memphis & North Mississippi."} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title ? `${title} | ${siteName}` : siteName} />
      <meta name="twitter:description" content={description || "Black-owned, woman-led brokerage offering personalized real estate services in Memphis & North Mississippi."} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Bespoke Realty" />
    </Helmet>
  );
};

export default SEO;
